import { z } from "zod";

export const schema = z.object({
    setor: z.string().min(1, "Unidade é obrigatória"),
    ordem: z.string().min(1, "Ordem é obrigatório"),
    tipo: z.string().min(1, "Tipo é obrigatória"),
    ativo: z.boolean().default(true),
    user: z.array(z.string()).min(1, "Responsável é obrigatório"),
});